import { shape, string } from "prop-types";

export const TradeLabelShape = shape({
  key: string,
  value: string,
  text: string
});

export default TradeLabelShape;
